<template>
    <a-config-provider :theme="antdTheme">
        <div id="components-layout-demo-side" class="app-root" :data-theme="theme_mode">
            <router-view v-if="is_login" />
            <div v-else-if="use_embed_layout" class="embed-layout">
                <div class="page-host">
                    <router-view />
                </div>
            </div>
            <a-layout v-else class="app-main-layout">
                <a-layout-sider
                    v-model:collapsed="collapsed"
                    collapsible
                    class="app-sider"
                    :theme="siderTheme"
                >
                    <div class="logo">
                        <h4 v-if="!collapsed" class="sider-title">{{ sname }}</h4>
                        <img v-else :src="slogo" class="sider-logo-img"/>
                    </div>
                    <a-menu v-model:selectedKeys="selectedKeys" :theme="siderTheme" mode="inline">
                        <a-menu-item key="1" @click="openPage('waitlist')">
                            <ProfileOutlined />
                            <span>{{ $t('waitlist.waitlist') }}</span>
                        </a-menu-item>
                        <a-menu-item key="2" @click="openPage('reserve')">
                            <CalendarOutlined />
                            <span>{{ $t('reserve.reserve') }}</span>
                        </a-menu-item>
                        <a-menu-item key="3" :disabled="true" v-if="false">
                            <AppstoreOutlined />
                            <span>{{ $t('floorplan.floorplan') }}</span>
                        </a-menu-item>
                        <a-sub-menu key="sub1" v-if="false">
                            <template #title>
                                <span>
                                    <span>User</span>
                                </span>
                            </template>
                            <a-menu-item key="3">Tom</a-menu-item>
                            <a-menu-item key="4">Bill</a-menu-item>
                            <a-menu-item key="5">Alex</a-menu-item>
                        </a-sub-menu>
                        <a-divider />
                        <a-menu-item key="5" @click="openPage('setting')">
                            <SettingOutlined />
                            <span>{{ $t('setting.setting')}}</span>
                        </a-menu-item>
                    </a-menu>
                    <h5 v-if="!collapsed" class="app-sider-version sider-version-expanded">{{ $t('setting.version_label') }} {{ version + ' (' + build_number + ')' }}</h5>
                    <h5 v-else class="app-sider-version sider-version-collapsed">{{ version }}</h5>
                </a-layout-sider>
                <a-layout class="app-content-layout">
                    <a-layout-content class="app-content" :class="{ 'with-footer-nav': is_mobile }">
                        <div class="page-host">
                            <router-view/>
                        </div>
                        <a-flex v-if="is_mobile" class="footer_nav">
                            <div class="footer_nav_item" @click="openPage('waitlist')" :class="{current: now_path.indexOf('/waitlist') > -1}">
                                <span><ProfileOutlined /></span>
                                <span style="padding-top: 5px;">{{ $t('waitlist.waitlist') }}</span>
                            </div>
                            <div class="footer_nav_item" @click="openPage('reserve')" style="border-left: none; border-right: none;" :class="{current: now_path.indexOf('/reserve') > -1}">
                                <span><CalendarOutlined /></span>
                                <span style="padding-top: 5px;">{{ $t('reserve.reserve') }}</span>
                            </div>
                            <div class="footer_nav_item" @click="openPage('setting')" :class="{current: now_path.indexOf('/setting') > -1}">
                                <span><SettingOutlined /></span>
                                <span style="padding-top: 5px;">{{ $t('setting.setting')}}</span>
                            </div>
                        </a-flex>
                    </a-layout-content>
                </a-layout>
            </a-layout>
        </div>
    </a-config-provider>
</template>

<script>
    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
    import { theme } from 'ant-design-vue';
    import { applyEmbedFromQuery, isEmbedQuery, readEmbedMode } from './kits/embedMode';

    import {
        ProfileOutlined,
        CalendarOutlined,
        AppstoreOutlined,
        SettingOutlined,
    } from '@ant-design/icons-vue';
    
    export default {
        name: 'AppPage',
        components: {
            ProfileOutlined,
            CalendarOutlined,
            AppstoreOutlined,
            SettingOutlined,
        },
        data() {
            const path = this.$router.currentRoute.value.fullPath;
            return {
                is_login:
                    path.indexOf('/login') > -1 ||
                    path.indexOf('/register') > -1 ||
                    path.indexOf('/sso/') > -1,
                collapsible: false,
                selectedKeys: [],
                collapsed: false,
                sid: this.$store.state.app.sid,
                token: this.$store.state.app.token,
                version: this.$store.state.app.version,
                build_number: this.$store.state.app.build_number,
                now_path: this.$router.currentRoute.value.fullPath,
            };
        },
        beforeMount() {
            this.is_login = this.isBlankLayoutPath(this.$router.currentRoute.value.fullPath);
            this.syncEmbedFlag();
        },
        mounted() {
            this.syncMobileFlag();
            this.syncEmbedFlag();
            window.addEventListener('resize', this.syncMobileFlag);
        },
        beforeUnmount() {
            window.removeEventListener('resize', this.syncMobileFlag);
        },
        watch: {
            '$route'() {
                this.is_login = this.isBlankLayoutPath(this.$router.currentRoute.value.fullPath);
                this.syncEmbedFlag();

                let now_path = this.$router.currentRoute.value.fullPath;
                this.now_path = now_path;

                if (now_path.indexOf('/waitlist') > -1) {
                    this.selectedKeys = ['1'];
                } else if (now_path.indexOf('/reserve') > -1) {
                    this.selectedKeys = ['2'];
                } else if (now_path.indexOf('/setting') > -1) {
                    this.selectedKeys = ['5'];
                }
            }
        },
        computed: {
            ...mapGetters({
            }),
            ...mapState({
                sname: state => state.app.sname,
                slogo: state => state.app.slogo,
                embed_mode: state => state.app.embed_mode,
                is_mobile: state => state.app.is_mobile,
                theme_mode: state => state.app.theme_mode,
            }),
            isDark() {
                return this.theme_mode === 'dark';
            },
            siderTheme() {
                // 侧栏始终用 dark 菜单皮肤，底色由 CSS 变量随主题切换，避免菜单白底+容器深蓝的断层
                return 'dark';
            },
            antdTheme() {
                return {
                    algorithm: this.isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
                };
            },
            use_embed_layout() {
                return (
                    this.embed_mode ||
                    readEmbedMode() ||
                    isEmbedQuery(this.$route.query)
                );
            },
        },
        methods: {
            syncMobileFlag() {
                const mobile = window.innerWidth < 768;
                if (mobile !== this.$store.state.app.is_mobile) {
                    this.APP_SET_IS_MOBILE(mobile);
                }
            },
            syncEmbedFlag() {
                const enabled = applyEmbedFromQuery(this.$route.query);
                this.APP_SET_EMBED_MODE(enabled);
            },
            isBlankLayoutPath(path) {
                return (
                    path.indexOf('/login') > -1 ||
                    path.indexOf('/register') > -1 ||
                    path.indexOf('/sso/') > -1
                );
            },
            openPage(type) {
                if (type === 'waitlist') {
                    this.$router.push({
                        path: '/waitlist'
                    });
                } else if (type === 'reserve') {
                    this.$router.push({
                        path: '/reserve'
                    });
                } else if (type === 'setting') {
                    this.$router.push({
                        path: '/setting'
                    });
                }
            },
            ...mapActions({
            }),
            ...mapMutations({
                APP_SET_IS_MOBILE: 'app/APP_SET_IS_MOBILE',
                APP_SET_EMBED_MODE: 'app/APP_SET_EMBED_MODE',
            })
        }
    };

</script>

<style>
    html,
    body,
    #app {
        height: 100%;
        margin: 0;
        overflow: hidden;
    }
</style>

<style scoped>
    .app-root {
        height: 100%;
        max-height: 100%;
        overflow: hidden;
        background: var(--app-bg);
        color: var(--app-text);
    }

    .app-main-layout,
    .app-content-layout {
        height: 100%;
        min-height: 0;
        overflow: hidden;
        background: var(--app-bg);
    }

    .app-content {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 0;
        margin: 0 !important;
        padding: 16px;
        overflow: hidden;
        box-sizing: border-box;
        background: var(--app-bg);
    }

    .app-content.with-footer-nav {
        padding-bottom: 60px;
    }

    .page-host {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .page-host > :deep(*) {
        flex: 1;
        min-height: 0;
        height: 100%;
        max-height: 100%;
    }

    .embed-layout {
        height: 100%;
        overflow: hidden;
        background: var(--app-bg);
        display: flex;
        flex-direction: column;
        padding: 12px;
        box-sizing: border-box;
    }

    .embed-layout .page-host {
        flex: 1;
        min-height: 0;
    }

    #components-layout-demo-side .logo {
        height: 40px;
        margin: 16px;
    }

    .sider-title {
        width: 100%;
        overflow: hidden;
        line-height: 40px;
        text-align: center;
        color: var(--app-sider-text);
        margin: 0;
    }

    .sider-logo-img {
        width: 50px;
        height: auto;
        margin: 0 auto;
        display: block;
    }

    .app-sider-version {
        text-align: center;
        color: var(--app-sider-text);
        position: fixed;
    }

    .sider-version-expanded {
        bottom: 50px;
        left: 50px;
    }

    .sider-version-collapsed {
        bottom: 50px;
        left: 25px;
    }

    .footer_nav {
        display: flex;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 100;
        margin: 0;
    }

    .footer_nav .footer_nav_item {
        width: 33.33%;
        display: inline-block;
        text-align: center;
        height: 55px;
        font-size: 16px;
        color: var(--app-footer-text);
        background-color: var(--app-footer-bg);
        padding-top: 7px;
        border-top: 1px solid var(--app-border);
        box-sizing: border-box;
    }

    .footer_nav .footer_nav_item span {
        display: block;
    }

    .footer_nav .footer_nav_item.current {
        color: #1677ff;
    }

    @media screen and (max-width: 768px) {
        .app-sider {
            display: none !important;
        }

        .app-content {
            padding: 5px;
        }

        .app-content.with-footer-nav {
            padding-bottom: 60px;
        }

        .embed-layout {
            padding: 5px;
        }
    }
</style>
